import React from "react";

import { Header } from "semantic-ui-react";

import OrganizationInformationForm from "../../../components/forms/OrganizationInformationForm";
import UsersTable from "../../../components/UsersTable";

const BasicSettingsView = () => {
  return (
    <div>
      <Header dividing as="h4">
        Organization information
      </Header>
      <OrganizationInformationForm />
      <Header dividing as="h4">
        Users
      </Header>
      <UsersTable />
    </div>
  );
};

export default BasicSettingsView;



// WEBPACK FOOTER //
// ./frontend/src/views/pages/settings/BasicSettingsView.js